import { Switch } from "antd";
import React from "react";

interface SwitchProps {
	label?: string;
	onChange?: (value: any) => void;
	checked?: boolean;
}

const DefaultSwitch: React.FC<SwitchProps> = ({ label, onChange, checked }) => {
	return (
		<div className="flex gap-3.5 justify-center items-center ">
			<Switch
				onChange={onChange}
				checked={checked}
				className=" border border-solid border-[#E0E4EB] h-6"
				style={{
					backgroundColor: checked ? "#4F16C2" : "white",
					outline: "none",
				}}
			/>
			<label>{label}</label>
		</div>
	);
};

export default DefaultSwitch;
